import DateRangeFilter from "../widgets/DateRangeFilter";
import AccountFilter from "../widgets/AccountFilter";
import SearchFilter from "../widgets/SearchFilter"

export default function DividendsToolbar(){
    return <div className="toolbar flex middle gap-8">
        <AccountFilter/>
        <SearchFilter/>
        <DateRangeFilter/>
    </div>
}